<template>
  <div class="finance-card">
    <b-card class="info-card">
      <div class="bold-text main-color-text">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            {{ $t('operation.Finance') }}
          </div>
        </div>
        <div class="row mt-3">
          <div v-if="isButtonVisible('dossier')" class="col-md-6 pr-1 w-100">
            <b-button
              id="finance-dossier"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini', {'custom-disabled': !operationBilanId}]"
              :disabled="!operationBilanId"
              v-b-tooltip:hover="!operationBilanId ? 'Vous devez réaliser le bilan AVP pour accéder à cet onglet' : ''"
              variant="primary"
              @click="operationBilanId ? showDossier() : null">
              {{ $t("operation.finance.dossier") }}
            </b-button>
          </div>
          <div v-if="isButtonVisible('emprunt')" class="col-md-6 pl-1 w-100">
            <b-button
              id="finance-emprunt"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini']"
              variant="primary"
              @click="showEmprunt()">
              {{ $t("operation.finance.emprunt") }}
            </b-button>
          </div>

          <div v-if="isButtonVisible('investisseur')" class="col-md-6 w-100 pr-1 mt-2">
            <b-button
              id="finance-investor"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini']"
              variant="primary"
              @click="showInvestor()">
              {{ $t("operation.finance.investisseur") }}
            </b-button>
          </div>
          <div v-if="isButtonVisible('tresorerie')" class="col-md-6 pl-1 w-100 mt-2">
            <b-button
              id="finance-tresorerie"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini']"
              variant="primary"
              @click="showTreasury()">
              {{ $t("operation.finance.tresorerie") }}
            </b-button>
          </div>
          <div v-if="isButtonVisible('devisFactures')" class="col-md-6 pr-1 w-100 mt-2">
            <b-button
              id="finance-devis-factures"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini', {'custom-disabled': !operationBilanId}]"
              v-b-tooltip:hover="!operationBilanId ? 'Vous devez réaliser le bilan AVP pour accéder à cet onglet' : ''"
              variant="primary"
              @click="operationBilanId ? clickOnDevisFacturesBtn() : null">
              {{ $t("operation.finance.devisFactures") }}
            </b-button>
          </div>



          <div v-if="isButtonVisible('echeance') && operationLotsFiltered && operationLotsFiltered.length > 0" class="col-md-6 pl-1 w-100 mt-2">
            <b-button
              id="finance-echeance"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini']"
              variant="primary"
              @click="showEcheance()">
              {{ $t("operation.finance.echeance") }}
            </b-button>
          </div>

          <!-- Bouton Devis temporairement désactivé
          <div v-if="isButtonVisible('devis')" class="col-md-6 pr-1 w-100 mt-2">
            <b-button
              id="finance-devis"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini', {'custom-disabled': !operationBilanId}]"
              v-b-tooltip:hover="!operationBilanId ? 'Vous devez réaliser le bilan AVP pour accéder à cet onglet' : ''"
              variant="primary"
              @click="operationBilanId ? clickOnDevisBtn() : null">
              {{ $t("operation.finance.devis") }}
            </b-button>
          </div>
          -->
          <!-- Bouton Factures temporairement désactivé
          <div v-if="isButtonVisible('factures') && bilanType === 'EXE'" class="col-md-6 pl-1 w-100 mt-2">
            <b-button
              id="finance-factures"
              :class="[`${bilanType.toLowerCase()}-btn`, 'col-md-12', 'finance', 'mini']"
              variant="primary"
              @click="clickOnFacturesBtn()">
              {{ $t("operation.finance.factures") }}
            </b-button>
          </div>
          -->
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "FinanceCardPagination",

  props: {
    bilanType: {
      type: String,
      default: "AVP"
    },
    operationBilanId: {
      type: [Number, null],
      default: null
    },
    operationId: {
      type: Number,
      required: true
    },
    operationType: {
      type: String,
      default: null
    },
    operationLots: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      buttonsConfig: ['dossier', 'emprunt', 'investisseur', 'devisFactures', 'tresorerie', 'echeance']
    }
  },
  computed: {
    operationLotsFiltered() {
      console.log(this.operationLots)
      if (this.operationType === 'DEFAULT') return []
      else if (this.operationType === 'VIR') return this.operationLots.filter(lot => lot.isLotVir)
      return this.operationLots
    },
  },

  methods: {
    isButtonVisible(buttonName) {
      return this.buttonsConfig.includes(buttonName);
    },

    showDossier() {
      this.$router.push({
        name: 'OperationShowDossier',
        params: {
          operationId: this.operationId,
          dossierOperationCreationDone: this.$parent.operation.dossierOperationCreationDone
        }
      });
    },

    showEmprunt() {
      this.$router.push({
        name: 'OperationShowEmprunt',
        params: {
          operationId: this.operationId,
          operationDate: this.$parent.operationDate,
        }
      });
    },

    showInvestor() {
      this.$router.push({
        name: 'OperationShowInvestor',
        params: {
          operationId: this.operationId,
        }
      });
    },

    showTreasury() {
      this.$router.push({
        name: 'TreasuryShow',
        params: {
          operationId: this.operationId,
        }
      });
    },

    clickOnDevisBtn() {
      this.$router.push({
        name: 'OperationDevisIndex',
        params: {
          operationId: this.operationId,
        }
      });
    },

    clickOnFacturesBtn() {
      this.$router.push({
        name: 'OperationFactureIndex',
        params: {
          operationId: this.operationId,
        }
      });
    },

    clickOnDevisFacturesBtn() {
      this.$router.push({
        name: 'OperationDevisFacturesIndex',
        params: {
          operationId: this.operationId,
        }
      });
    },

    showEcheance() {
      this.$router.push({
        name: 'ScheduleShow',
        params: {
          operationId: this.operationId,
          operationType: this.operationType,
        },
      });
    }
  }
}
</script>

<style scoped>
.info-card {
  height: 100%;
  position: relative;
}

.mini {
  font-size: 11px;
}


.custom-disabled {
  opacity: 0.65 !important;
  cursor: default !important;
}

/* AVP Button Styles */
.avp-btn {
  background-color: var(--avp-color) !important;
  border: none !important;
  color: var(--main-white) !important;
  border-radius: var(--main-border-radius) !important;
}

.avp-btn:hover:not(.custom-disabled) {
  background-color: var(--avp-color-hover) !important;
}

.exe-btn {
  background-color: var(--exe-color) !important;
  border: none !important;
  color: var(--main-white) !important;
  border-radius: var(--main-border-radius) !important;
}

.exe-btn:hover:not(.custom-disabled) {
  background-color: var(--exe-color-hover) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/components/FinanceCardPagination.vue